module.exports = __webpack_public_path__ + "img/img1.fc5846ea.jpg";